import createLucideIcon from '../createLucideIcon';

const FlagTriangleRight = createLucideIcon('FlagTriangleRight', [
  ['path', { d: 'M7 22V2l10 5-10 5', key: '17n18y' }],
]);

export default FlagTriangleRight;
